import React, { useContext, useEffect } from 'react';
import MyContext from '../context/MyContext';
import HistoryInvoice from './HistoryInvoice';
import axios from 'axios';


const ViewOrders = () => {
  const { history, setHistory } = useContext(MyContext);

  useEffect(() => {
    const getHistory = async () => {
      const res = await axios.get('/api/payments');
      setHistory(res.data);
    };
    getHistory();
  }, [setHistory]);

  const invoicesList = history.map((item) => (
    <HistoryInvoice item={item} key={item._id}></HistoryInvoice>
  ));

  return (
    <div className='history-page'>
      <h1>Order History</h1>
      <h4>We have Total{history.length} ordered</h4>
      <table>
        <thead>
          <tr>
            <th>Payment ID</th>
            <th>Date</th>
            <th>Clients</th>
            <th>Shipping Status</th>
            <th>Details</th>
            <th>Update</th>
          </tr>
        </thead>
        <tbody>{invoicesList}</tbody>
      </table>
    </div>
  );
};

export default ViewOrders;